module.exports = __webpack_public_path__ + "static/img/219_TO8_1941.8df3096.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/219_TO8_1941.jpg
// module id = 5xgT
// module chunks = 0